<template>
    <PaginationContainer
            @changedPage="changedPage"
            @changedPageSize="changedPageSize"
    >
        <TrimsTable
                :isCustomerTrims="false"
                :trims="trims"
                :dataFetching="dataFetching"
                @search="searchTrims"
        ></TrimsTable>
    </PaginationContainer>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import PaginationContainer from "../../../../components/pagination/PaginationContainer";
    import TrimsTable from "../../../trims/TrimsTable";

    export default {
        name: "UserCreatedTrimsTab",

        components: {
            TrimsTable,
            PaginationContainer,
        },

        data() {
            return {
                dataFetching: false,
                searchQuery: {},
            }
        },

        computed: {
            ...mapState('pagination', [
                'currentPage',
            ]),

            ...mapState('users', [
                'currentUserId',
            ]),

            ...mapState('trims', [
                'trims',
            ]),

        },

        methods: {
            ...mapActions('pagination', [
                'setPage',
            ]),

            ...mapActions('trims', [
                'getTrimsByQuery',
                'savePaginationPageSize',
            ]),

            searchTrims({searchQuery, page}) {
                // use mainParams only if searching by user or customer
                const userId = this.currentUserId;
                const mainParams = { userId };

                // set from the search fields
                this.searchQuery = searchQuery;

                this.dataFetching = true;

                // get and set trims
                this.getTrimsByQuery({ mainParams, searchParams: searchQuery, page })
                    .finally(() => {
                        this.dataFetching = false;
                    });

                this.setPage(page);
            },

            changedPage(page) {
                this.searchTrims({searchQuery: this.searchQuery, page});
            },

            changedPageSize(pageSize) {
                // save pagination params for "trims"
                this.savePaginationPageSize(pageSize);

                this.changedPage(this.currentPage);
            },

        },

    }
</script>

<style lang="scss">

</style>